import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import Collection from "@components/views/Profile/Addresses/Collection";

const CollectionPage = () => <Collection />;

export async function getServerSideProps({ params: { locale } }) {
  return {
    props: {
      ...(await getMessagesForNamespaces(locale, [
        "common",
        "addresses",
        "accounts",
        "address_form",
      ])),
    },
  };
}

export default CollectionPage;
